"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoboothCell = exports.Photobooth = void 0;
var _react = _interopRequireWildcard(require("react"));
var bodyPix = _interopRequireWildcard(require("@tensorflow-models/body-pix"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _qrcode = require("qrcode.react");
var _axios = _interopRequireDefault(require("axios"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #B40024;\n  color: white;\n  position: relative;\n  padding: 1rem 2rem;\n  min-height: 100vh;\n  box-sizing: border-box;\n  overflow-y: auto;\n"])));
var Header = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  position: relative;\n  max-height: 15vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n"])));
var BackButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: white;\n  cursor: pointer;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 1rem;\n  padding: 0;\n  width: 2.2rem;\n  height: 2.2rem;\n  line-height: 0;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"])), function (props) {
  return props.show ? 'flex' : 'none';
});
var Logo = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  text-align: center;\n"])));
var Title = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-style: normal;\n  font-size: 1.2rem;\n  font-weight: bold;\n  text-align: center;\n  padding-bottom: 5px;\n"])));
var NotJust = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: 'Gotham', sans-serif;\n  font-style: normal;\n  width: 100%;\n  font-weight: bold;\n  text-align: center;\n  position: relative;\n  min-height: 6rem;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n"])));
var TextOption = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-style: normal;\n  font-size: 2.1rem;\n  font-weight: bold;\n  text-align: right;\n"])));
var MainContent = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 95%;\n  max-width: 750px;\n  margin: 0 auto;\n  flex: 1;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  max-height: 85vh;\n"])));
var PreviewCard = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  border-radius: 2rem;\n  padding: 2rem 2rem 0.5rem 2rem;\n  margin: 10px 0;\n  box-shadow: 5px 8px 12px rgba(0,0,0,0.4);\n  border: solid;\n  background-color: #B40024;\n"])));
var PhotoGrid = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto auto;\n  gap: 1rem;\n"])));
var PhotoCell = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: relative;\n  aspect-ratio: 1;\n  overflow: hidden;\n  background-image: url(", ");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  transform: scaleX(-1);\n"])), function (props) {
  return props.imageUrl;
});
var Photo = _styledComponents.default.img(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n"])));
var CameraButton = _styledComponents.default.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.4);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(10px);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0.5rem auto;\n  cursor: pointer;\n  color: white;\n  padding: 1rem;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"])));
var CameraButtonLabel = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: 'Gotham', sans-serif;\n  font-size: 1.4rem;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 10px;\n  color: white;\n"])));
var TextSelect = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var TextButton = _styledComponents.default.button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0.7rem;\n  background: transparent;\n  border: none;\n  border-radius: 2.5rem;\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"])));
var OptionButton = _styledComponents.default.button(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: absolute; /* This makes it fixed relative to nearest positioned ancestor */\n  left: 7rem; /* Aligns to left */\n  top: 50%; /* Centers vertically */\n  transform: translateY(-50%); /* Ensures perfect vertical centering */\n  width: 2rem;\n  height: 2rem;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n\n"])));
var TextOptions = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: -7rem;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 1.5rem;\n  z-index: 10;\n  display: block;\n  width: 11rem;\n  backdrop-filter: blur(20px);\n  display: ", ";\n"])), function (props) {
  return props.show ? 'block' : 'none';
});
var RetakeButton = _styledComponents.default.button(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: 55%;\n  padding: 0.9rem;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  border-radius: 2.5rem;\n  color: white;\n  font-size: 1rem;\n  margin: 1rem auto 0 auto;\n  cursor: pointer;\n\n  /* Flex styling */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px; /* space between icon and text */\n  \n  /* Optional: style the icon if needed */\n  svg {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n"])));
var LogoComponent = _styledComponents.default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  width:6.25rem;\n  height: 1.25rem;\n  margin: 1rem auto;\n\n  background: rgba(255, 255, 255, 0.25);\n  border: solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(9.5px);\n  border-radius: 1.625rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var LogoTreeosk = _styledComponents.default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  background: url('/logo_treeosk.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 4rem;\n  height: 0.75rem;\n"])));
var ActionButton = _styledComponents.default.button(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  width: 80%;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 2.5rem;\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0.9rem auto 0 auto;\n  box-shadow: 5px 5px 10px rgba(0,0,0,0.2);\n  cursor: pointer;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"])));
var QROverlay = _styledComponents.default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(180, 0, 36, 0.8);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n"])));
var QRContainer = _styledComponents.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  border-radius: 3.2rem;\n  border: solid #fff;\n  padding: 2rem 5rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.3);\n  box-shadow: 10px 15px 30px rgba(58, 28, 0, 0.25);\n  backdrop-filter: blur(29px);\n  -webkit-backdrop-filter: blur(29px); /* For Safari */\n"])));
var QRText = _styledComponents.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  color: white;\n  margin: 2rem 0;\n  font-size: 1.4rem;\n  line-height: normal;\n  text-align: center;\n"])));
var VideoContainer = _styledComponents.default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 95%;\n  aspect-ratio: 3.6/5;\n  background: #f0f0f0;\n  border-radius: 2rem;\n  overflow: hidden;\n  margin: 20px auto;\n  border: solid;\n  box-shadow: 5px 8px 12px rgba(0,0,0,0.4);\n"])));
var Video = _styledComponents.default.video(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: scaleX(-1);\n"])));
var Canvas = _styledComponents.default.canvas(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var PreviewOverlay = _styledComponents.default.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(180, 0, 36, 0.95);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n"])));
var PreviewContainer = _styledComponents.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  padding: 30px;\n  border-radius: 2rem;\n  text-align: center;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow: auto;\n  border: solid;\n"])));
var PreviewImage = _styledComponents.default.img(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: 60vh;\n  object-fit: contain;\n  margin-bottom: 20px;\n"])));
var PreviewText = _styledComponents.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  color: white;\n  margin: 20px 0;\n  font-size: 16px;\n  text-align: center;\n"])));
var textOptions = ['a pretty girl', 'a lover', 'a mum', 'an office girlie', 'a dreamer', 'a powerful girl'];
var DownloadButton = _styledComponents.default.button(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  width: 80%;\n  padding: 1rem;\n  background: ", ";\n  border: none;\n  border-radius: 2.5rem;\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0.9rem auto 0 auto;\n  box-shadow: 5px 5px 10px rgba(0,0,0,0.2);\n  cursor: ", ";\n  position: relative;\n  transition: background 0.3s ease;\n  \n  &:hover {\n    background: ", ";\n  }\n  \n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])), function (props) {
  return props.loading ? 'rgba(180, 180, 180, 0.3)' : 'rgba(255, 255, 255, 0.2)';
}, function (props) {
  return props.loading ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.loading ? 'rgba(180, 180, 180, 0.3)' : 'rgba(255, 255, 255, 0.3)';
});
var LoadingText = _styledComponents.default.span(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.3s ease;\n"])), function (props) {
  return props.visible ? '1' : '0';
});
var PhotoboothCell = function PhotoboothCell(_ref0) {
  var preview = _ref0.preview,
    cell = _ref0.cell,
    project = _ref0.project,
    _ref0$uriTransformer = _ref0.uriTransformer,
    uriTransformer = _ref0$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref0$uriTransformer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "photobooth-cell ".concat(preview ? 'preview' : '')
  }, /*#__PURE__*/_react.default.createElement("h3", null, cell.title), /*#__PURE__*/_react.default.createElement("p", null, cell.description), cell.background_image_uri && /*#__PURE__*/_react.default.createElement("img", {
    src: cell.background_image_uri,
    alt: "Photobooth Background"
  }));
};
exports.PhotoboothCell = PhotoboothCell;
var Photobooth = function Photobooth(_ref1) {
  var cell = _ref1.cell,
    _ref1$preview = _ref1.preview,
    preview = _ref1$preview === void 0 ? true : _ref1$preview,
    project = _ref1.project,
    _ref1$uriTransformer = _ref1.uriTransformer,
    uriTransformer = _ref1$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref1$uriTransformer,
    intl = _ref1.intl,
    defaultLanguage = _ref1.defaultLanguage;
  var videoRef = (0, _react.useRef)(null);
  var canvasRef = (0, _react.useRef)(null);
  var _ref10 = (0, _react.useState)(null),
    _ref11 = _slicedToArray(_ref10, 2),
    model = _ref11[0],
    setModel = _ref11[1];
  var _ref12 = (0, _react.useState)(false),
    _ref13 = _slicedToArray(_ref12, 2),
    isProcessing = _ref13[0],
    setIsProcessing = _ref13[1];
  var _ref14 = (0, _react.useState)(null),
    _ref15 = _slicedToArray(_ref14, 2),
    processedImages = _ref15[0],
    setProcessedImages = _ref15[1];
  var _ref16 = (0, _react.useState)(false),
    _ref17 = _slicedToArray(_ref16, 2),
    showQR = _ref17[0],
    setShowQR = _ref17[1];
  var _ref18 = (0, _react.useState)(false),
    _ref19 = _slicedToArray(_ref18, 2),
    isStreamReady = _ref19[0],
    setIsStreamReady = _ref19[1];
  var _ref20 = (0, _react.useState)(null),
    _ref21 = _slicedToArray(_ref20, 2),
    stream = _ref21[0],
    setStream = _ref21[1];
  var _ref22 = (0, _react.useState)('welcome'),
    _ref23 = _slicedToArray(_ref22, 2),
    step = _ref23[0],
    setStep = _ref23[1];
  var _ref24 = (0, _react.useState)('NOT JUST'),
    _ref25 = _slicedToArray(_ref24, 1),
    mainText = _ref25[0];
  var _ref26 = (0, _react.useState)(function () {
      var saved = 'a pretty girl';
      return saved || 'a pretty girl';
    }),
    _ref27 = _slicedToArray(_ref26, 2),
    subText = _ref27[0],
    setSubText = _ref27[1];
  var _ref28 = (0, _react.useState)(true),
    _ref29 = _slicedToArray(_ref28, 2),
    showTextOptions = _ref29[0],
    setShowTextOptions = _ref29[1];
  var _ref30 = (0, _react.useState)(function () {
      var saved = localStorage.getItem('lastUsedFilter');
      return saved || 'red';
    }),
    _ref31 = _slicedToArray(_ref30, 2),
    activeFilter = _ref31[0],
    setActiveFilter = _ref31[1];
  var _ref32 = (0, _react.useState)(false),
    _ref33 = _slicedToArray(_ref32, 2),
    showPreview = _ref33[0],
    setShowPreview = _ref33[1];
  var _ref34 = (0, _react.useState)(null),
    _ref35 = _slicedToArray(_ref34, 2),
    previewImage = _ref35[0],
    setPreviewImage = _ref35[1];
  var _ref36 = (0, _react.useState)(null),
    _ref37 = _slicedToArray(_ref36, 2),
    currentPhoto = _ref37[0],
    setCurrentPhoto = _ref37[1];
  var _ref38 = (0, _react.useState)(null),
    _ref39 = _slicedToArray(_ref38, 2),
    countdown = _ref39[0],
    setCountdown = _ref39[1];
  var countdownRef = (0, _react.useRef)(null);
  var _ref40 = (0, _react.useState)(''),
    _ref41 = _slicedToArray(_ref40, 2),
    link = _ref41[0],
    setLink = _ref41[1];
  var _ref42 = (0, _react.useState)(''),
    _ref43 = _slicedToArray(_ref42, 2),
    email = _ref43[0],
    setEmail = _ref43[1];
  var _ref44 = (0, _react.useState)(false),
    _ref45 = _slicedToArray(_ref44, 2),
    isLoading = _ref45[0],
    setIsLoading = _ref45[1];
  var _ref46 = (0, _react.useState)(null),
    _ref47 = _slicedToArray(_ref46, 2),
    country = _ref47[0],
    setCountry = _ref47[1];
  var _ref48 = (0, _react.useState)({}),
    _ref49 = _slicedToArray(_ref48, 2),
    textDatas = _ref49[0],
    setTextDatas = _ref49[1];
  var getCurrentPosition = function getCurrentPosition() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };
  var loadCountry = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var position, _position$coords, latitude, longitude, _country, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return getCurrentPosition();
          case 1:
            position = _context.v;
            _position$coords = position.coords, latitude = _position$coords.latitude, longitude = _position$coords.longitude;
            console.log('Latitude:', latitude);
            console.log('Longitude:', longitude);
            _context.n = 2;
            return getCountryFromCoords(latitude, longitude);
          case 2:
            _country = _context.v;
            console.log('Country:', _country);
            setCountry(_country);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t2 = _context.v;
            console.error('Erreur lors de la récupération de la géolocalisation :', _t2);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function loadCountry() {
      return _ref.apply(this, arguments);
    };
  }();
  var uploadPhoto = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var captureCardAsImage, completeCardImage, response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (currentPhoto) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            captureCardAsImage = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var cardElement, html2canvas, canvas, properCanvas, ctx;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      cardElement = document.querySelector(".card-container");
                      _context2.n = 1;
                      return Promise.resolve().then(function () {
                        return _interopRequireWildcard(require('html2canvas'));
                      });
                    case 1:
                      html2canvas = _context2.v;
                      _context2.n = 2;
                      return html2canvas.default(cardElement, {
                        useCORS: true,
                        scale: 2,
                        allowTaint: true,
                        backgroundColor: null,
                        imageTimeout: 0
                      });
                    case 2:
                      canvas = _context2.v;
                      properCanvas = document.createElement('canvas');
                      ctx = properCanvas.getContext('2d');
                      properCanvas.width = cardElement.offsetWidth * 2; // Scale factor of 2
                      properCanvas.height = cardElement.offsetHeight * 2; // Scale factor of 2

                      ctx.drawImage(canvas, 0, 0);
                      return _context2.a(2, properCanvas.toDataURL('image/jpeg', 0.9));
                  }
                }, _callee2);
              }));
              return function captureCardAsImage() {
                return _ref3.apply(this, arguments);
              };
            }();
            _context3.p = 2;
            _context3.n = 3;
            return captureCardAsImage();
          case 3:
            completeCardImage = _context3.v;
            _context3.n = 4;
            return _axios.default.post("".concat(project.backEndUri, "/send_photo"), {
              cell_id: cell.id,
              image: completeCardImage,
              additional_data: {
                email: email,
                choice: subText,
                country: country
              },
              email: email
            });
          case 4:
            response = _context3.v;
            if (!response) {
              _context3.n = 5;
              break;
            }
            console.log('Photo with frame uploaded successfully:', response.data);
            setLink(response.data.image_uri);
            return _context3.a(2, response);
          case 5:
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t3 = _context3.v;
            console.error('Error uploading photo:', _t3);
          case 7:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 6]]);
    }));
    return function uploadPhoto() {
      return _ref2.apply(this, arguments);
    };
  }();
  var downloadPhoto = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(imageUrl) {
      var downloadUrl, response, blob, blobUrl, downloadLink, _response, _blob, _blobUrl, _downloadLink, _t4, _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            downloadUrl = imageUrl || link;
            if (downloadUrl) {
              _context4.n = 1;
              break;
            }
            console.error('No image link available to download');
            return _context4.a(2);
          case 1:
            if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
              _context4.n = 7;
              break;
            }
            _context4.p = 2;
            _context4.n = 3;
            return fetch(downloadUrl);
          case 3:
            response = _context4.v;
            _context4.n = 4;
            return response.blob();
          case 4:
            blob = _context4.v;
            blobUrl = window.URL.createObjectURL(blob);
            downloadLink = document.createElement('a');
            downloadLink.href = blobUrl;
            downloadLink.download = "photo.jpeg";
            downloadLink.style.display = 'none';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            setTimeout(function () {
              window.URL.revokeObjectURL(blobUrl);
              document.body.removeChild(downloadLink);
            }, 100);
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t4 = _context4.v;
            console.error('Error downloading on iOS:', _t4);
            alert('Error downloading image. Please try again.');
          case 6:
            _context4.n = 11;
            break;
          case 7:
            _context4.p = 7;
            _context4.n = 8;
            return fetch(downloadUrl);
          case 8:
            _response = _context4.v;
            _context4.n = 9;
            return _response.blob();
          case 9:
            _blob = _context4.v;
            _blobUrl = window.URL.createObjectURL(_blob);
            _downloadLink = document.createElement('a');
            _downloadLink.href = _blobUrl;
            _downloadLink.download = "photo.jpeg";
            document.body.appendChild(_downloadLink);
            _downloadLink.click();
            setTimeout(function () {
              window.URL.revokeObjectURL(_blobUrl);
              document.body.removeChild(_downloadLink);
            }, 100);
            _context4.n = 11;
            break;
          case 10:
            _context4.p = 10;
            _t5 = _context4.v;
            console.error('Error downloading image:', _t5);
            alert('Failed to download image. Please try again.');
          case 11:
            return _context4.a(2);
        }
      }, _callee4, null, [[7, 10], [2, 5]]);
    }));
    return function downloadPhoto(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleDownload = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var response, _t6;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            setIsLoading(true);
            _context5.p = 1;
            _context5.n = 2;
            return uploadPhoto();
          case 2:
            response = _context5.v;
            if (!(cell.with_email && response && response.data)) {
              _context5.n = 3;
              break;
            }
            _context5.n = 3;
            return downloadPhoto(response.data.image_uri);
          case 3:
            _context5.n = 4;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 4:
            setShowQR(true);
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t6 = _context5.v;
            console.error('Error in download process:', _t6);
            alert('There was an error processing your download. Please try again.');
          case 6:
            _context5.p = 6;
            setIsLoading(false);
            return _context5.f(6);
          case 7:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 5, 6, 7]]);
    }));
    return function handleDownload() {
      return _ref5.apply(this, arguments);
    };
  }();
  var ResponsiveNotJust = function ResponsiveNotJust() {
    var containerRef = (0, _react.useRef)(null);
    var textRef = (0, _react.useRef)(null);
    var _ref50 = (0, _react.useState)(4),
      _ref51 = _slicedToArray(_ref50, 2),
      fontSize = _ref51[0],
      setFontSize = _ref51[1]; // Initial font size in rem

    var adjustTextSize = (0, _react.useCallback)(function () {
      if (!containerRef.current || !textRef.current) return;
      var containerWidth = containerRef.current.offsetWidth;
      var containerHeight = containerRef.current.offsetHeight;

      // Reset font size to small
      var size = 20;
      textRef.current.style.fontSize = "".concat(size, "rem");

      // Binary search approach for faster convergence
      var minSize = 0.1;
      var maxSize = 100;
      var bestSize = size;
      while (maxSize - minSize > 0.1) {
        size = (minSize + maxSize) / 2;
        textRef.current.style.fontSize = "".concat(size, "rem");
        if (textRef.current.offsetWidth < containerWidth * 0.95 && textRef.current.offsetHeight < containerHeight * 0.95) {
          // Text is too small, try larger
          bestSize = size;
          minSize = size;
        } else {
          // Text is too large, try smaller
          maxSize = size;
        }
      }

      // Fine-tune: gradually increase until just before overflow
      size = bestSize;
      var stillFits = true;
      while (stillFits && size < 20) {
        size += 0.1;
        textRef.current.style.fontSize = "".concat(size, "rem");
        if (textRef.current.offsetWidth > containerWidth * 0.98 || textRef.current.offsetHeight > containerHeight * 0.98) {
          size -= 0.1;
          textRef.current.style.fontSize = "".concat(size, "rem");
          stillFits = false;
        }
      }
      setFontSize(size);
    }, []);
    (0, _react.useEffect)(function () {
      // Run adjustment on mount
      adjustTextSize();

      // Set up resize observer with debounce
      var timeoutId = null;
      var resizeObserver = new ResizeObserver(function () {
        // Debounce the resize events
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          adjustTextSize();
        }, 100);
      });
      if (containerRef.current) {
        resizeObserver.observe(containerRef.current);
      }

      // Also add window resize listener as a fallback
      window.addEventListener('resize', adjustTextSize);

      // Force a recalculation after a short delay to ensure proper rendering
      setTimeout(adjustTextSize, 500);

      // Cleanup
      return function () {
        if (timeoutId) clearTimeout(timeoutId);
        if (containerRef.current) {
          resizeObserver.unobserve(containerRef.current);
        }
        window.removeEventListener('resize', adjustTextSize);
      };
    }, [adjustTextSize]);
    return /*#__PURE__*/_react.default.createElement(NotJust, {
      ref: containerRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: textRef,
      style: {
        fontSize: "".concat(fontSize, "rem"),
        whiteSpace: 'nowrap',
        display: 'inline-block'
      }
    }, mainText));
  };
  (0, _react.useEffect)(function () {
    if (processedImages) {
      console.log('Processed images updated:', processedImages);
    }
  }, [processedImages]);
  (0, _react.useEffect)(function () {
    localStorage.setItem('lastUsedText', subText);
  }, [subText]);
  (0, _react.useEffect)(function () {
    localStorage.setItem('lastUsedFilter', activeFilter);
  }, [activeFilter]);
  (0, _react.useEffect)(function () {
    var loadModel = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var loadedModel, _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return bodyPix.load({
                architecture: 'MobileNetV1',
                outputStride: 16,
                multiplier: 0.75,
                quantBytes: 2
              });
            case 1:
              loadedModel = _context6.v;
              setModel(loadedModel);
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t7 = _context6.v;
              console.error('Error loading model:', _t7);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 2]]);
      }));
      return function loadModel() {
        return _ref6.apply(this, arguments);
      };
    }();
    loadModel();
    return function () {
      if (stream) {
        stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    loadCountry();
  }, []);
  var setupCamera = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var constraints, success, _i, _constraints, constraint, newStream, _t8, _t9;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            _context7.p = 0;
            // Clean up previous stream if exists
            if (stream) {
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });
              setStream(null);
            }

            // Try different camera constraints
            constraints = [{
              video: {
                facingMode: 'user',
                width: {
                  ideal: 1280
                },
                height: {
                  ideal: 720
                }
              }
            }, {
              video: {
                facingMode: 'user'
              }
            }, {
              video: true
            }];
            success = false;
            _i = 0, _constraints = constraints;
          case 1:
            if (!(_i < _constraints.length)) {
              _context7.n = 8;
              break;
            }
            constraint = _constraints[_i];
            _context7.p = 2;
            _context7.n = 3;
            return navigator.mediaDevices.getUserMedia(constraint);
          case 3:
            newStream = _context7.v;
            if (!videoRef.current) {
              _context7.n = 5;
              break;
            }
            videoRef.current.srcObject = newStream;
            setStream(newStream);

            // Wait for video to be ready
            _context7.n = 4;
            return new Promise(function (resolve) {
              videoRef.current.onloadedmetadata = function () {
                resolve();
              };
            });
          case 4:
            // Set canvas dimensions
            if (canvasRef.current) {
              canvasRef.current.width = videoRef.current.videoWidth;
              canvasRef.current.height = videoRef.current.videoHeight;
            }
            setIsStreamReady(true);
            success = true;

            // Start processing frames
            requestAnimationFrame(_processFrame);
            return _context7.a(3, 8);
          case 5:
            _context7.n = 7;
            break;
          case 6:
            _context7.p = 6;
            _t8 = _context7.v;
            console.warn('Failed with constraint:', constraint, _t8);
            return _context7.a(3, 7);
          case 7:
            _i++;
            _context7.n = 1;
            break;
          case 8:
            if (success) {
              _context7.n = 9;
              break;
            }
            throw new Error('Could not access camera with any constraints');
          case 9:
            _context7.n = 11;
            break;
          case 10:
            _context7.p = 10;
            _t9 = _context7.v;
            console.error('Error accessing camera:', _t9);
            // Show user-friendly error message
            alert('Camera access is required for the photobooth. Please enable camera permissions and try again.');
            setStep('welcome'); // Go back to design step
          case 11:
            return _context7.a(2);
        }
      }, _callee7, null, [[2, 6], [0, 10]]);
    }));
    return function setupCamera() {
      return _ref7.apply(this, arguments);
    };
  }();
  var startCamera = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            setStep('capture');
            _context8.n = 1;
            return setupCamera();
          case 1:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return function startCamera() {
      return _ref8.apply(this, arguments);
    };
  }();
  var _processFrame = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var video, canvas, ctx, segmentation, backgroundBlurAmount, edgeBlurAmount, flipHorizontal, _t0;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            if (!(!model || !videoRef.current || !canvasRef.current || !isStreamReady || isProcessing || step !== 'capture')) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2);
          case 1:
            video = videoRef.current;
            canvas = canvasRef.current;
            ctx = canvas.getContext('2d');
            _context9.p = 2;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            _context9.n = 3;
            return model.segmentPerson(video, {
              flipHorizontal: false,
              internalResolution: 'medium',
              segmentationThreshold: 0.7
            });
          case 3:
            segmentation = _context9.v;
            if (!segmentation) {
              _context9.n = 4;
              break;
            }
            backgroundBlurAmount = 3;
            edgeBlurAmount = 3;
            flipHorizontal = false;
            _context9.n = 4;
            return bodyPix.drawBokehEffect(canvas, video, segmentation, backgroundBlurAmount, edgeBlurAmount, flipHorizontal);
          case 4:
            if (step === 'capture') {
              requestAnimationFrame(_processFrame);
            }
            _context9.n = 6;
            break;
          case 5:
            _context9.p = 5;
            _t0 = _context9.v;
            console.error('Error processing frame:', _t0);
            if (step === 'capture') {
              requestAnimationFrame(_processFrame);
            }
          case 6:
            return _context9.a(2);
        }
      }, _callee9, null, [[2, 5]]);
    }));
    return function processFrame() {
      return _ref9.apply(this, arguments);
    };
  }();
  var applyFilter = function applyFilter(ctx, imageData) {
    var data = imageData.data;
    switch (activeFilter) {
      case 'red':
        for (var i = 0; i < data.length; i += 4) {
          data[i] = Math.min(255, data[i] * 0.705882353); // Red
          data[i + 1] = Math.max(0, data[i + 1] * 0); // Green
          data[i + 2] = Math.max(0, data[i + 2] * 0.141176471); // Blue
          data[i + 3] = 255; // Alpha
        }
        break;
      case 'sepia':
        for (var _i2 = 0; _i2 < data.length; _i2 += 4) {
          var r = data[_i2];
          var g = data[_i2 + 1];
          var b = data[_i2 + 2];
          data[_i2] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
          data[_i2 + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
          data[_i2 + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
        }
        break;
      case 'grayscale':
        for (var _i3 = 0; _i3 < data.length; _i3 += 4) {
          var avg = (data[_i3] + data[_i3 + 1] + data[_i3 + 2]) / 3;
          data[_i3] = avg;
          data[_i3 + 1] = avg;
          data[_i3 + 2] = avg;
        }
        break;
      case 'invert':
        for (var _i4 = 0; _i4 < data.length; _i4 += 4) {
          data[_i4] = 255 - data[_i4];
          data[_i4 + 1] = 255 - data[_i4 + 1];
          data[_i4 + 2] = 255 - data[_i4 + 2];
        }
        break;
      default:
        break;
    }
    return imageData;
  };
  var startCountdown = function startCountdown() {
    setCountdown(3);
    countdownRef.current = setInterval(function () {
      setCountdown(function (prev) {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          capturePhoto();
          setTimeout(function () {
            if (stream) {
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });
              setStream(null);
            }
            setIsStreamReady(false);
          }, 500);
          return null;
        }
        return prev - 1;
      });
    }, 1000);
  };
  (0, _react.useEffect)(function () {
    return function () {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, []);
  var capturePhoto = function capturePhoto() {
    if (!canvasRef.current || !videoRef.current) return;
    setIsProcessing(true);
    var canvas = canvasRef.current;
    var video = videoRef.current;

    // Create a temporary canvas with the same dimensions as the video
    var tempCanvas = document.createElement('canvas');
    tempCanvas.width = video.videoWidth;
    tempCanvas.height = video.videoHeight;
    var ctx = tempCanvas.getContext('2d');

    // First, draw the video frame
    ctx.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);

    // Then, draw the segmentation canvas on top
    ctx.drawImage(canvas, 0, 0, tempCanvas.width, tempCanvas.height);

    // Get the initial image data URL with high quality
    var initialImage = tempCanvas.toDataURL('image/jpeg', 0.95);

    // Immediately update the current photo and show preview
    setCurrentPhoto(initialImage);
    setShowPreview(true);

    // Process images in the background
    var img = new Image();
    img.onload = function () {
      var originalCanvas = document.createElement('canvas');
      var filteredCanvas = document.createElement('canvas');
      originalCanvas.width = img.width;
      originalCanvas.height = img.height;
      filteredCanvas.width = img.width;
      filteredCanvas.height = img.height;
      var originalCtx = originalCanvas.getContext('2d');
      var filteredCtx = filteredCanvas.getContext('2d');

      // Create original version - draw the image at full quality
      originalCtx.drawImage(img, 0, 0);
      var original = originalCanvas.toDataURL('image/jpeg', 0.95);

      // Create filtered version
      filteredCtx.drawImage(img, 0, 0);
      var imageData = filteredCtx.getImageData(0, 0, filteredCanvas.width, filteredCanvas.height);
      var filteredImageData = applyFilter(filteredCtx, imageData);
      filteredCtx.putImageData(filteredImageData, 0, 0);
      var filtered = filteredCanvas.toDataURL('image/jpeg', 0.95);

      // Update both current photo and processed images
      setCurrentPhoto(original);
      setProcessedImages({
        original: original,
        filtered: filtered
      });

      // Save to localStorage
      try {
        localStorage.setItem('lastPhoto', JSON.stringify({
          original: original,
          filtered: filtered,
          filter: activeFilter,
          mainText: mainText,
          subText: subText,
          timestamp: Date.now()
        }));
      } catch (error) {
        console.warn('Failed to save to localStorage:', error);
      }
      setStep('design');
      setIsProcessing(false);
    };
    img.onerror = function (error) {
      console.error('Error loading image:', error);
      setIsProcessing(false);
    };
    img.src = initialImage;
  };
  var handleBack = function handleBack() {
    setShowQR(false);
    switch (step) {
      case 'design':
        setStep('capture');
        setProcessedImages(null);
        setupCamera();
        break;
      case 'capture':
        if (stream) {
          stream.getTracks().forEach(function (track) {
            return track.stop();
          });
          setStream(null);
        }
        setIsStreamReady(false);
        setStep('welcome');
        break;
      case 'edit':
        setStep('design');
        break;
      case 'final':
        setStep('edit');
        setShowTextOptions(true);
        break;
      default:
        break;
    }
  };
  var handleClosePreview = function handleClosePreview() {
    setShowPreview(false);
    setPreviewImage(null);
    setStep('final');
  };
  var renderContent = function renderContent() {
    switch (step) {
      case 'welcome':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PhotoGrid, null, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: uriTransformer("https://web-treeosk.online/apks/sample-photo.jpg"),
          alt: "Sample"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: uriTransformer("https://web-treeosk.online/apks/sample-photo-red.jpg"),
          alt: "Sample filtered"
        }))), /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer("https://web-treeosk.online/apks/NOT_JUST.png"),
          alt: "not just",
          style: {
            width: '100%',
            padding: '5px 0'
          }
        }), /*#__PURE__*/_react.default.createElement(TextOption, null, subText), /*#__PURE__*/_react.default.createElement(PhotoGrid, {
          style: {
            marginTop: '0.5rem'
          }
        }, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: uriTransformer("https://web-treeosk.online/apks/sample-photo-red.jpg"),
          alt: "Sample filtered"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: uriTransformer("https://web-treeosk.online/apks/sample-photo.jpg"),
          alt: "Sample"
        }))), /*#__PURE__*/_react.default.createElement(CameraButton, {
          onClick: startCamera
        }, /*#__PURE__*/_react.default.createElement("svg", {
          style: {
            minWidth: '2rem',
            minHeight: '2rem'
          },
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          className: "lucide lucide-camera-icon lucide-camera"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "13",
          r: "3"
        }))), /*#__PURE__*/_react.default.createElement(CameraButtonLabel, null, (0, _utils.i18nData)(cell, 'click_to_start_text', intl, defaultLanguage) || textDatas.clickToStart || 'CLICK TO START'), /*#__PURE__*/_react.default.createElement(LogoComponent, null, /*#__PURE__*/_react.default.createElement(LogoTreeosk, null)));
      case 'design':
        var lastPhoto = function () {
          try {
            var saved = localStorage.getItem('lastPhoto');
            if (saved) {
              var parsed = JSON.parse(saved);
              if (Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
                return parsed;
              }
            }
          } catch (error) {
            console.warn('Failed to load last photo:', error);
          }
          return null;
        }();
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewCard, null, /*#__PURE__*/_react.default.createElement(PhotoGrid, null, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: lastPhoto && lastPhoto.original ? lastPhoto.original : uriTransformer("https://web-treeosk.online/apks/sample-photo.jpg"),
          alt: "Sample"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: lastPhoto && lastPhoto.filtered ? lastPhoto.filtered : uriTransformer("https://web-treeosk.online/apks/sample-photo-red.jpg"),
          alt: "Sample filtered"
        }))), /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer("https://web-treeosk.online/apks/NOT_JUST.png"),
          alt: "not just",
          style: {
            width: '100%',
            padding: '5px 0'
          }
        }), /*#__PURE__*/_react.default.createElement(TextOption, null, subText), /*#__PURE__*/_react.default.createElement(PhotoGrid, {
          style: {
            marginTop: '1rem'
          }
        }, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: lastPhoto && lastPhoto.filtered ? lastPhoto.filtered : uriTransformer("https://web-treeosk.online/apks/sample-photo-red.jpg"),
          alt: "Sample filtered"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: lastPhoto && lastPhoto.original ? lastPhoto.original : uriTransformer("https://web-treeosk.online/apks/sample-photo.jpg"),
          alt: "Sample"
        }))), /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer('https://web-treeosk.online/apks/clarins_logo.png'),
          alt: "Clarins",
          style: {
            width: '50%'
          }
        }))), /*#__PURE__*/_react.default.createElement(ActionButton, {
          onClick: function onClick() {
            setStep('edit');
            setShowTextOptions(true);
          }
        }, (0, _utils.i18nData)(cell, 'customise_message_text', intl, defaultLanguage) || textDatas.customiseMessage || 'CUSTOMISE YOUR MESSAGE'), /*#__PURE__*/_react.default.createElement(RetakeButton, {
          onClick: startCamera
        }, /*#__PURE__*/_react.default.createElement("svg", {
          width: "38",
          height: "42",
          viewBox: "0 0 38 42",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M19.0004 26.0572C18.5273 26.0572 18.0737 26.2369 17.7391 26.5569C17.4046 26.8769 17.2167 27.3108 17.2167 27.7633C17.2167 28.2158 17.4046 28.6498 17.7391 28.9697C18.0737 29.2897 18.5273 29.4694 19.0004 29.4694C20.7643 29.4694 22.4886 28.9691 23.9552 28.0318C25.4218 27.0944 26.5649 25.7621 27.2399 24.2033C27.9149 22.6446 28.0915 20.9294 27.7474 19.2746C27.4033 17.6198 26.5539 16.0998 25.3066 14.9068C24.0594 13.7137 22.4703 12.9013 20.7403 12.5721C19.0103 12.243 17.2171 12.4119 15.5875 13.0576C13.9579 13.7032 12.565 14.7966 11.585 16.1995C10.6051 17.6023 10.082 19.2516 10.082 20.9388C10.082 21.3913 10.27 21.8253 10.6045 22.1452C10.939 22.4652 11.3926 22.6449 11.8657 22.6449C12.3388 22.6449 12.7924 22.4652 13.127 22.1452C13.4615 21.8253 13.6494 21.3913 13.6494 20.9388C13.6494 19.9265 13.9632 18.9369 14.5512 18.0952C15.1392 17.2535 15.9749 16.5975 16.9526 16.2101C17.9304 15.8227 19.0063 15.7213 20.0443 15.9188C21.0823 16.1163 22.0358 16.6038 22.7841 17.3196C23.5325 18.0354 24.0421 18.9474 24.2486 19.9403C24.4551 20.9331 24.3491 21.9623 23.9441 22.8975C23.5391 23.8328 22.8532 24.6322 21.9733 25.1946C21.0933 25.757 20.0587 26.0572 19.0004 26.0572Z",
          fill: "white"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M38 29.596V12.1866C38 10.3397 37.2721 8.56843 35.9764 7.26247C34.6807 5.95651 32.9233 5.22283 31.0909 5.22283H28.5605L26.6432 2.32416C26.1692 1.60809 25.5269 1.02121 24.7736 0.615726C24.0202 0.210243 23.1791 -0.00127021 22.325 5.73873e-06H15.6664C14.8123 -0.00127021 13.9712 0.210243 13.2178 0.615726C12.4644 1.02121 11.8222 1.60809 11.3482 2.32416L9.43955 5.22283H6.90909C5.07669 5.22283 3.31933 5.95651 2.02363 7.26247C0.72792 8.56843 0 10.3397 0 12.1866V29.596C0 31.4429 0.72792 33.2142 2.02363 34.5201C3.31933 35.8261 5.07669 36.5598 6.90909 36.5598H11.3741L9.14591 38.8143C8.9651 38.9704 8.81824 39.1624 8.71457 39.3784C8.61089 39.5944 8.55263 39.8297 8.54344 40.0694C8.53425 40.3092 8.57433 40.5483 8.66117 40.7717C8.74801 40.9951 8.87973 41.198 9.04806 41.3676C9.21639 41.5373 9.4177 41.6701 9.63935 41.7576C9.861 41.8451 10.0982 41.8855 10.3361 41.8763C10.574 41.867 10.8074 41.8083 11.0217 41.7038C11.236 41.5993 11.4265 41.4513 11.5814 41.269L16.7632 36.0462C17.0849 35.72 17.2655 35.2788 17.2655 34.8188C17.2655 34.3589 17.0849 33.9177 16.7632 33.5915L11.5814 28.3686C11.2509 28.0834 10.8259 27.9344 10.3912 27.9513C9.95647 27.9682 9.5441 28.1499 9.23648 28.4599C8.92886 28.77 8.74865 29.1856 8.73186 29.6238C8.71507 30.0619 8.86294 30.4903 9.14591 30.8234L11.3741 33.0779H6.90909C5.99289 33.0779 5.11421 32.7111 4.46636 32.0581C3.81851 31.4051 3.45455 30.5195 3.45455 29.596V12.1866C3.45455 11.2631 3.81851 10.3775 4.46636 9.72453C5.11421 9.07155 5.99289 8.70471 6.90909 8.70471H10.3636C10.6473 8.70418 10.9266 8.63322 11.1766 8.4981C11.4266 8.36298 11.6398 8.16787 11.7973 7.92999L14.2327 4.25661C14.3902 4.01873 14.6034 3.82362 14.8534 3.6885C15.1034 3.55338 15.3827 3.48242 15.6664 3.48189H22.3336C22.6173 3.48242 22.8966 3.55338 23.1466 3.6885C23.3966 3.82362 23.6098 4.01873 23.7673 4.25661L26.2027 7.92999C26.3602 8.16787 26.5734 8.36298 26.8234 8.4981C27.0734 8.63322 27.3527 8.70418 27.6364 8.70471H31.0909C32.0071 8.70471 32.8858 9.07155 33.5336 9.72453C34.1815 10.3775 34.5455 11.2631 34.5455 12.1866V29.596C34.5455 30.5195 34.1815 31.4051 33.5336 32.0581C32.8858 32.7111 32.0071 33.0779 31.0909 33.0779H22.5064C22.0483 33.0779 21.6089 33.2613 21.285 33.5878C20.9611 33.9143 20.7791 34.3571 20.7791 34.8188C20.7791 35.2806 20.9611 35.7234 21.285 36.0499C21.6089 36.3764 22.0483 36.5598 22.5064 36.5598H31.0909C32.9233 36.5598 34.6807 35.8261 35.9764 34.5201C37.2721 33.2142 38 31.4429 38 29.596Z",
          fill: "white"
        })), "RETAKE THE PHOTO"));
      case 'capture':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(VideoContainer, null, /*#__PURE__*/_react.default.createElement(Video, {
          ref: videoRef,
          autoPlay: true,
          playsInline: true,
          muted: true
        }), /*#__PURE__*/_react.default.createElement(Canvas, {
          ref: canvasRef
        }), countdown !== null && /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownText, null, countdown))), /*#__PURE__*/_react.default.createElement(CameraButton, {
          onClick: startCountdown,
          disabled: isProcessing || countdown !== null
        }, /*#__PURE__*/_react.default.createElement("svg", {
          style: {
            minWidth: '2rem',
            minHeight: '2rem'
          },
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          className: "lucide lucide-camera-icon lucide-camera"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "13",
          r: "3"
        }))), /*#__PURE__*/_react.default.createElement(CameraButtonLabel, null, isProcessing ? (0, _utils.i18nData)(cell, 'processing_text', intl, defaultLanguage) || textDatas.processing || 'PROCESSING...' : countdown !== null ? (0, _utils.i18nData)(cell, 'get_ready_text', intl, defaultLanguage) || textDatas.getReady || 'GET READY!' : (0, _utils.i18nData)(cell, 'take_photo_text', intl, defaultLanguage) || textDatas.takePhoto || 'TAKE THE PHOTO'));
      case 'edit':
        return processedImages && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewCard, null, /*#__PURE__*/_react.default.createElement(PhotoGrid, null, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: processedImages.original,
          alt: "Original"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: processedImages.filtered,
          alt: "Filtered"
        }))), /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer("https://web-treeosk.online/apks/NOT_JUST.png"),
          alt: "not just",
          style: {
            width: '100%',
            padding: '5px 0'
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }
        }, /*#__PURE__*/_react.default.createElement(TextSelect, null, /*#__PURE__*/_react.default.createElement(OptionButton, {
          onClick: function onClick() {
            return setShowTextOptions(!showTextOptions);
          }
        }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faChevronRight,
          style: {
            width: '0.4em'
          }
        })), /*#__PURE__*/_react.default.createElement(TextOptions, {
          show: showTextOptions
        }, textOptions.map(function (option) {
          return /*#__PURE__*/_react.default.createElement(TextButton, {
            key: option,
            onClick: function onClick() {
              setSubText(option);
              setShowTextOptions(false);
            }
          }, option);
        }))), /*#__PURE__*/_react.default.createElement(TextOption, null, subText)), /*#__PURE__*/_react.default.createElement(PhotoGrid, {
          style: {
            marginTop: '1rem'
          }
        }, /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: processedImages.filtered,
          alt: "Filtered"
        })), /*#__PURE__*/_react.default.createElement(PhotoCell, null, /*#__PURE__*/_react.default.createElement(Photo, {
          src: processedImages.original,
          alt: "Original"
        }))), /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer('https://web-treeosk.online/apks/clarins_logo.png'),
          alt: "Clarins",
          style: {
            width: '50%'
          }
        }))), /*#__PURE__*/_react.default.createElement(ActionButton, {
          onClick: function onClick() {
            return setStep('final');
          }
        }, (0, _utils.i18nData)(cell, 'preview_image_text', intl, defaultLanguage) || textDatas.previewImage || 'PREVIEW YOUR IMAGE'), /*#__PURE__*/_react.default.createElement(RetakeButton, {
          onClick: startCamera
        }, /*#__PURE__*/_react.default.createElement("svg", {
          width: "38",
          height: "42",
          viewBox: "0 0 38 42",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M19.0004 26.0572C18.5273 26.0572 18.0737 26.2369 17.7391 26.5569C17.4046 26.8769 17.2167 27.3108 17.2167 27.7633C17.2167 28.2158 17.4046 28.6498 17.7391 28.9697C18.0737 29.2897 18.5273 29.4694 19.0004 29.4694C20.7643 29.4694 22.4886 28.9691 23.9552 28.0318C25.4218 27.0944 26.5649 25.7621 27.2399 24.2033C27.9149 22.6446 28.0915 20.9294 27.7474 19.2746C27.4033 17.6198 26.5539 16.0998 25.3066 14.9068C24.0594 13.7137 22.4703 12.9013 20.7403 12.5721C19.0103 12.243 17.2171 12.4119 15.5875 13.0576C13.9579 13.7032 12.565 14.7966 11.585 16.1995C10.6051 17.6023 10.082 19.2516 10.082 20.9388C10.082 21.3913 10.27 21.8253 10.6045 22.1452C10.939 22.4652 11.3926 22.6449 11.8657 22.6449C12.3388 22.6449 12.7924 22.4652 13.127 22.1452C13.4615 21.8253 13.6494 21.3913 13.6494 20.9388C13.6494 19.9265 13.9632 18.9369 14.5512 18.0952C15.1392 17.2535 15.9749 16.5975 16.9526 16.2101C17.9304 15.8227 19.0063 15.7213 20.0443 15.9188C21.0823 16.1163 22.0358 16.6038 22.7841 17.3196C23.5325 18.0354 24.0421 18.9474 24.2486 19.9403C24.4551 20.9331 24.3491 21.9623 23.9441 22.8975C23.5391 23.8328 22.8532 24.6322 21.9733 25.1946C21.0933 25.757 20.0587 26.0572 19.0004 26.0572Z",
          fill: "white"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M38 29.596V12.1866C38 10.3397 37.2721 8.56843 35.9764 7.26247C34.6807 5.95651 32.9233 5.22283 31.0909 5.22283H28.5605L26.6432 2.32416C26.1692 1.60809 25.5269 1.02121 24.7736 0.615726C24.0202 0.210243 23.1791 -0.00127021 22.325 5.73873e-06H15.6664C14.8123 -0.00127021 13.9712 0.210243 13.2178 0.615726C12.4644 1.02121 11.8222 1.60809 11.3482 2.32416L9.43955 5.22283H6.90909C5.07669 5.22283 3.31933 5.95651 2.02363 7.26247C0.72792 8.56843 0 10.3397 0 12.1866V29.596C0 31.4429 0.72792 33.2142 2.02363 34.5201C3.31933 35.8261 5.07669 36.5598 6.90909 36.5598H11.3741L9.14591 38.8143C8.9651 38.9704 8.81824 39.1624 8.71457 39.3784C8.61089 39.5944 8.55263 39.8297 8.54344 40.0694C8.53425 40.3092 8.57433 40.5483 8.66117 40.7717C8.74801 40.9951 8.87973 41.198 9.04806 41.3676C9.21639 41.5373 9.4177 41.6701 9.63935 41.7576C9.861 41.8451 10.0982 41.8855 10.3361 41.8763C10.574 41.867 10.8074 41.8083 11.0217 41.7038C11.236 41.5993 11.4265 41.4513 11.5814 41.269L16.7632 36.0462C17.0849 35.72 17.2655 35.2788 17.2655 34.8188C17.2655 34.3589 17.0849 33.9177 16.7632 33.5915L11.5814 28.3686C11.2509 28.0834 10.8259 27.9344 10.3912 27.9513C9.95647 27.9682 9.5441 28.1499 9.23648 28.4599C8.92886 28.77 8.74865 29.1856 8.73186 29.6238C8.71507 30.0619 8.86294 30.4903 9.14591 30.8234L11.3741 33.0779H6.90909C5.99289 33.0779 5.11421 32.7111 4.46636 32.0581C3.81851 31.4051 3.45455 30.5195 3.45455 29.596V12.1866C3.45455 11.2631 3.81851 10.3775 4.46636 9.72453C5.11421 9.07155 5.99289 8.70471 6.90909 8.70471H10.3636C10.6473 8.70418 10.9266 8.63322 11.1766 8.4981C11.4266 8.36298 11.6398 8.16787 11.7973 7.92999L14.2327 4.25661C14.3902 4.01873 14.6034 3.82362 14.8534 3.6885C15.1034 3.55338 15.3827 3.48242 15.6664 3.48189H22.3336C22.6173 3.48242 22.8966 3.55338 23.1466 3.6885C23.3966 3.82362 23.6098 4.01873 23.7673 4.25661L26.2027 7.92999C26.3602 8.16787 26.5734 8.36298 26.8234 8.4981C27.0734 8.63322 27.3527 8.70418 27.6364 8.70471H31.0909C32.0071 8.70471 32.8858 9.07155 33.5336 9.72453C34.1815 10.3775 34.5455 11.2631 34.5455 12.1866V29.596C34.5455 30.5195 34.1815 31.4051 33.5336 32.0581C32.8858 32.7111 32.0071 33.0779 31.0909 33.0779H22.5064C22.0483 33.0779 21.6089 33.2613 21.285 33.5878C20.9611 33.9143 20.7791 34.3571 20.7791 34.8188C20.7791 35.2806 20.9611 35.7234 21.285 36.0499C21.6089 36.3764 22.0483 36.5598 22.5064 36.5598H31.0909C32.9233 36.5598 34.6807 35.8261 35.9764 34.5201C37.2721 33.2142 38 31.4429 38 29.596Z",
          fill: "white"
        })), (0, _utils.i18nData)(cell, 'retake_photo_text', intl, defaultLanguage) || textDatas.retakePhoto || 'RETAKE THE PHOTO'));
      case 'final':
        return processedImages && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewCard, {
          className: "card-container"
        }, /*#__PURE__*/_react.default.createElement(PhotoGrid, null, /*#__PURE__*/_react.default.createElement(PhotoCell, {
          imageUrl: processedImages.original
        }), /*#__PURE__*/_react.default.createElement(PhotoCell, {
          imageUrl: processedImages.filtered
        })), /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer("https://web-treeosk.online/apks/NOT_JUST.png"),
          alt: "not just",
          style: {
            width: '100%',
            padding: '5px 0'
          }
        }), /*#__PURE__*/_react.default.createElement(TextOption, null, subText), /*#__PURE__*/_react.default.createElement(PhotoGrid, {
          style: {
            marginTop: '1rem'
          }
        }, /*#__PURE__*/_react.default.createElement(PhotoCell, {
          imageUrl: processedImages.filtered
        }), /*#__PURE__*/_react.default.createElement(PhotoCell, {
          imageUrl: processedImages.original
        })), /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement("img", {
          src: "/clarins_logo.png",
          alt: "Clarins",
          style: {
            width: '50%'
          }
        }))), /*#__PURE__*/_react.default.createElement(DownloadButton, {
          onClick: handleDownload,
          disabled: isLoading
        }, isLoading ? /*#__PURE__*/_react.default.createElement(LoadingText, {
          visible: true
        }, "PROCESSING...") : /*#__PURE__*/_react.default.createElement(LoadingText, {
          visible: true
        }, "DOWNLOAD YOUR IMAGE")), /*#__PURE__*/_react.default.createElement(RetakeButton, {
          onClick: startCamera
        }, /*#__PURE__*/_react.default.createElement("svg", {
          width: "38",
          height: "42",
          viewBox: "0 0 38 42",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M19.0004 26.0572C18.5273 26.0572 18.0737 26.2369 17.7391 26.5569C17.4046 26.8769 17.2167 27.3108 17.2167 27.7633C17.2167 28.2158 17.4046 28.6498 17.7391 28.9697C18.0737 29.2897 18.5273 29.4694 19.0004 29.4694C20.7643 29.4694 22.4886 28.9691 23.9552 28.0318C25.4218 27.0944 26.5649 25.7621 27.2399 24.2033C27.9149 22.6446 28.0915 20.9294 27.7474 19.2746C27.4033 17.6198 26.5539 16.0998 25.3066 14.9068C24.0594 13.7137 22.4703 12.9013 20.7403 12.5721C19.0103 12.243 17.2171 12.4119 15.5875 13.0576C13.9579 13.7032 12.565 14.7966 11.585 16.1995C10.6051 17.6023 10.082 19.2516 10.082 20.9388C10.082 21.3913 10.27 21.8253 10.6045 22.1452C10.939 22.4652 11.3926 22.6449 11.8657 22.6449C12.3388 22.6449 12.7924 22.4652 13.127 22.1452C13.4615 21.8253 13.6494 21.3913 13.6494 20.9388C13.6494 19.9265 13.9632 18.9369 14.5512 18.0952C15.1392 17.2535 15.9749 16.5975 16.9526 16.2101C17.9304 15.8227 19.0063 15.7213 20.0443 15.9188C21.0823 16.1163 22.0358 16.6038 22.7841 17.3196C23.5325 18.0354 24.0421 18.9474 24.2486 19.9403C24.4551 20.9331 24.3491 21.9623 23.9441 22.8975C23.5391 23.8328 22.8532 24.6322 21.9733 25.1946C21.0933 25.757 20.0587 26.0572 19.0004 26.0572Z",
          fill: "white"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M38 29.596V12.1866C38 10.3397 37.2721 8.56843 35.9764 7.26247C34.6807 5.95651 32.9233 5.22283 31.0909 5.22283H28.5605L26.6432 2.32416C26.1692 1.60809 25.5269 1.02121 24.7736 0.615726C24.0202 0.210243 23.1791 -0.00127021 22.325 5.73873e-06H15.6664C14.8123 -0.00127021 13.9712 0.210243 13.2178 0.615726C12.4644 1.02121 11.8222 1.60809 11.3482 2.32416L9.43955 5.22283H6.90909C5.07669 5.22283 3.31933 5.95651 2.02363 7.26247C0.72792 8.56843 0 10.3397 0 12.1866V29.596C0 31.4429 0.72792 33.2142 2.02363 34.5201C3.31933 35.8261 5.07669 36.5598 6.90909 36.5598H11.3741L9.14591 38.8143C8.9651 38.9704 8.81824 39.1624 8.71457 39.3784C8.61089 39.5944 8.55263 39.8297 8.54344 40.0694C8.53425 40.3092 8.57433 40.5483 8.66117 40.7717C8.74801 40.9951 8.87973 41.198 9.04806 41.3676C9.21639 41.5373 9.4177 41.6701 9.63935 41.7576C9.861 41.8451 10.0982 41.8855 10.3361 41.8763C10.574 41.867 10.8074 41.8083 11.0217 41.7038C11.236 41.5993 11.4265 41.4513 11.5814 41.269L16.7632 36.0462C17.0849 35.72 17.2655 35.2788 17.2655 34.8188C17.2655 34.3589 17.0849 33.9177 16.7632 33.5915L11.5814 28.3686C11.2509 28.0834 10.8259 27.9344 10.3912 27.9513C9.95647 27.9682 9.5441 28.1499 9.23648 28.4599C8.92886 28.77 8.74865 29.1856 8.73186 29.6238C8.71507 30.0619 8.86294 30.4903 9.14591 30.8234L11.3741 33.0779H6.90909C5.99289 33.0779 5.11421 32.7111 4.46636 32.0581C3.81851 31.4051 3.45455 30.5195 3.45455 29.596V12.1866C3.45455 11.2631 3.81851 10.3775 4.46636 9.72453C5.11421 9.07155 5.99289 8.70471 6.90909 8.70471H10.3636C10.6473 8.70418 10.9266 8.63322 11.1766 8.4981C11.4266 8.36298 11.6398 8.16787 11.7973 7.92999L14.2327 4.25661C14.3902 4.01873 14.6034 3.82362 14.8534 3.6885C15.1034 3.55338 15.3827 3.48242 15.6664 3.48189H22.3336C22.6173 3.48242 22.8966 3.55338 23.1466 3.6885C23.3966 3.82362 23.6098 4.01873 23.7673 4.25661L26.2027 7.92999C26.3602 8.16787 26.5734 8.36298 26.8234 8.4981C27.0734 8.63322 27.3527 8.70418 27.6364 8.70471H31.0909C32.0071 8.70471 32.8858 9.07155 33.5336 9.72453C34.1815 10.3775 34.5455 11.2631 34.5455 12.1866V29.596C34.5455 30.5195 34.1815 31.4051 33.5336 32.0581C32.8858 32.7111 32.0071 33.0779 31.0909 33.0779H22.5064C22.0483 33.0779 21.6089 33.2613 21.285 33.5878C20.9611 33.9143 20.7791 34.3571 20.7791 34.8188C20.7791 35.2806 20.9611 35.7234 21.285 36.0499C21.6089 36.3764 22.0483 36.5598 22.5064 36.5598H31.0909C32.9233 36.5598 34.6807 35.8261 35.9764 34.5201C37.2721 33.2142 38 31.4429 38 29.596Z",
          fill: "white"
        })), "RETAKE THE PHOTO"));
      case 'preview':
        return /*#__PURE__*/_react.default.createElement(PreviewOverlay, null, /*#__PURE__*/_react.default.createElement(PreviewContainer, null, /*#__PURE__*/_react.default.createElement(PreviewImage, {
          src: previewImage,
          alt: "Preview"
        }), /*#__PURE__*/_react.default.createElement(PreviewText, null, "Your photo is ready!", /*#__PURE__*/_react.default.createElement("br", null), "Click below to share or retake."), /*#__PURE__*/_react.default.createElement(ActionButton, {
          onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
            return _regenerator().w(function (_context0) {
              while (1) switch (_context0.n) {
                case 0:
                  _context0.n = 1;
                  return uploadPhoto();
                case 1:
                  setShowQR(true);
                case 2:
                  return _context0.a(2);
              }
            }, _callee0);
          }))
        }, "SHARE YOUR PHOTO"), /*#__PURE__*/_react.default.createElement(ActionButton, {
          onClick: handleClosePreview
        }, "BACK")));
      default:
        return null;
    }
  };
  var fontFamily = project ? project.default_button_font : 'Gotham, sans-serif';
  return /*#__PURE__*/_react.default.createElement(Container, {
    style: {
      fontFamily: fontFamily
    }
  }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(BackButton, {
    show: step !== 'welcome',
    onClick: handleBack
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronLeft
  })), /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer('https://web-treeosk.online/apks/clarins_logo.png'),
    alt: "Clarins",
    style: {
      width: '40vw'
    }
  })), step === 'welcome' && /*#__PURE__*/_react.default.createElement(Title, null, (0, _utils.i18nData)(cell, 'create_photocard_text', intl, defaultLanguage) || textDatas.createPhotocard || 'Create your own photocard')), /*#__PURE__*/_react.default.createElement(MainContent, null, renderContent()), showQR && !cell.with_email && /*#__PURE__*/_react.default.createElement(QROverlay, null, /*#__PURE__*/_react.default.createElement(QRContainer, null, /*#__PURE__*/_react.default.createElement(QRText, null, (0, _utils.i18nData)(cell, 'scan_qr_code_text', intl, defaultLanguage) || textDatas.scanQRCode || 'Scan the QR code to download', /*#__PURE__*/_react.default.createElement("br", null), (0, _utils.i18nData)(cell, 'scan_qr_code_subtext', intl, defaultLanguage) || textDatas.scanQRCodeSubtext || 'the photo to your device.'), link.length && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '16rem',
      height: '16rem',
      background: 'white',
      padding: '1rem',
      borderRadius: '0.8rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: "100%",
    level: "H"
  }))), /*#__PURE__*/_react.default.createElement(ActionButton, {
    style: {
      width: '45%',
      background: 'rgba(255, 255, 255, 0.4)'
    },
    onClick: function onClick() {
      return setShowQR(false);
    }
  }, (0, _utils.i18nData)(cell, 'back_text', intl, defaultLanguage) || textDatas.back || 'BACK'), /*#__PURE__*/_react.default.createElement(RetakeButton, {
    style: {
      width: '35%',
      background: 'rgba(255, 255, 255, 0.4)'
    },
    onClick: function onClick() {
      setStep('welcome');
      setShowQR(false);
      setSubText('a pretty girl');
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-house-icon lucide-house"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })), (0, _utils.i18nData)(cell, 'home_page_text', intl, defaultLanguage) || textDatas.homePage || 'Home Page')), showQR && cell.with_email && /*#__PURE__*/_react.default.createElement(QROverlay, null, /*#__PURE__*/_react.default.createElement(QRContainer, null, /*#__PURE__*/_react.default.createElement(QRText, null, (0, _utils.i18nData)(cell, 'image_saved_text', intl, defaultLanguage) || textDatas.imageSaved || 'Image has been saved', /*#__PURE__*/_react.default.createElement("br", null), (0, _utils.i18nData)(cell, 'image_saved_subtext', intl, defaultLanguage) || textDatas.imageSavedSubtext || 'to your device.')), /*#__PURE__*/_react.default.createElement(ActionButton, {
    style: {
      width: '40%',
      background: 'rgba(255, 255, 255, 0.4)'
    },
    onClick: function onClick() {
      return setShowQR(false);
    }
  }, (0, _utils.i18nData)(cell, 'back_text', intl, defaultLanguage) || textDatas.back || 'BACK')));
};
exports.Photobooth = Photobooth;
var CountdownOverlay = _styledComponents.default.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 10rem;\n  height: 10rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px); /* For Safari */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownText = _styledComponents.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: 6.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n"])));
function getCountryFromCoords(_x2, _x3) {
  return _getCountryFromCoords.apply(this, arguments);
}
function _getCountryFromCoords() {
  _getCountryFromCoords = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(lat, lon) {
    var res, data, country, _t1;
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.p = _context1.n) {
        case 0:
          _context1.p = 0;
          _context1.n = 1;
          return fetch("https://nominatim.openstreetmap.org/reverse?format=json&lat=".concat(lat, "&lon=").concat(lon));
        case 1:
          res = _context1.v;
          _context1.n = 2;
          return res.json();
        case 2:
          data = _context1.v;
          country = data.address.country;
          return _context1.a(2, country);
        case 3:
          _context1.p = 3;
          _t1 = _context1.v;
          console.error("Erreur lors du reverse geocoding :", _t1);
          return _context1.a(2, null);
      }
    }, _callee1, null, [[0, 3]]);
  }));
  return _getCountryFromCoords.apply(this, arguments);
} // Add this line to export the Photobooth component
// export default PhotoboothCell; // Add this line to make PhotoboothCell the default export